/* Parans 相关产品 — 仅负责「系统推荐异步换入后」复初始化梯形轮播。
 *
 * 集合 / 产品列表来源时不需要本脚本（服务端已直出，parans-new-arrival.js 正常初始化）。
 * 系统推荐来源时，Dawn 的 <product-recommendations>(product-recommendations.js)
 * 会在滚动进视口后 fetch 本 section 的 section_id 渲染，并把内层 HTML 换入 ——
 * 这种 innerHTML 替换不会触发 shopify:section:load，于是新换入的 [data-pna] 不会被
 * parans-new-arrival.js 初始化。本脚本监听 [data-prp-reco] 的子树变化，发现新的
 * [data-pna] 后，在该 section 元素上派发 shopify:section:load —— parans-new-arrival.js
 * 监听该事件并对 e.target 内的 [data-pna] 初始化（e.target 即派发元素，天然受限于本 section）。
 */
(function () {
  function reinit(host) {
    var pna = host.querySelector("[data-pna]");
    if (!pna || pna.__pnaInited) return;
    // 在 section 容器上派发，使 parans-new-arrival.js 的 e.target 精确指向本 section。
    var target = host.closest(".shopify-section") || host;
    var evt;
    try {
      evt = new CustomEvent("shopify:section:load", { bubbles: true });
    } catch (e) {
      evt = document.createEvent("CustomEvent");
      evt.initCustomEvent("shopify:section:load", true, false, null);
    }
    target.dispatchEvent(evt);
  }

  function watch(host) {
    if (host.__prpWatched) return;
    host.__prpWatched = true;
    reinit(host); // 若脚本晚于换入，立即尝试一次
    var obs = new MutationObserver(function () {
      reinit(host);
    });
    obs.observe(host, { childList: true, subtree: true });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var hosts = root.querySelectorAll("[data-prp-reco]");
    for (var i = 0; i < hosts.length; i++) watch(hosts[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }
})();
